import { ANDROID_WRAPPER_EVENTS } from '@/event-manager/types';
import { sendAndroidWrapperEvent } from './wrapperHelpers';
import { PLATFORMS } from '@/utilities/constants/game.ts';
import { useStore } from '@/store/useStore';

export const openExternal = (url: string | undefined) => {
  if (!url) return;
  const { product, wrapperType } = useStore.getState().runtime;

  if (wrapperType.isAndroid) {
    if (product === PLATFORMS.XSELL) {
      return sendAndroidWrapperEvent(
        ANDROID_WRAPPER_EVENTS.OPEN_EXTERNAL_WEBVIEW,
        url,
      );
    }
    return sendAndroidWrapperEvent(ANDROID_WRAPPER_EVENTS.GAME_CLOSE, url);
  }
  return /gw./.test(url)
    ? window.location.replace(url)
    : window.open(url, '_blank');
};
